import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { expensesApi } from 'src/Services/API';

const useFetchExpenseBalance = (expenseId?: string) => {
  const assetId = useCurrentAssetId();
  return useQuery({
    queryKey: ['fetch-expense', expenseId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      if (!expenseId) throw new Error('No expenseId provided');

      return (await expensesApi.expensesControllerFindOne(expenseId, assetId)).data;
    },
    enabled: !!assetId && !!expenseId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchExpenseBalance;
